module.exports = __webpack_public_path__ + "static/media/thumb_CAPQ0131_1024.911f4799.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_CAPQ0131_1024.jpg
// module id = 133
// module chunks = 0